export default "__VITE_ASSET__DHFkUX14__"